// src/pages/dashboard/admin/admins/CreateAdmin.jsx
import { useState } from 'react';
import api from '../../../../lib/api';
import { success, error } from '../../../../components/common/Toast';

export default function CreateAdmin() {
  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    password: '',
    password_confirmation: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/admin/create-admin', form);
      success('Admin created successfully!');
      setForm({
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        password: '',
        password_confirmation: ''
      });
    } catch (err) {
      error(err.response?.data?.message || 'Failed to create admin');
    }
  };

  return (
    <div className="max-w-2xl mx-auto py-12 px-6">
      <h1 className="text-5xl font-black text-center mb-16">Create New Admin</h1>

      <form onSubmit={handleSubmit} className="bg-white rounded-3xl shadow-2xl p-12 space-y-8">
        <input
          type="text"
          placeholder="First Name"
          value={form.first_name}
          onChange={(e) => setForm({ ...form, first_name: e.target.value })}
          className="w-full px-6 py-5 rounded-2xl border-2 text-xl"
          required
        />
        <input
          type="text"
          placeholder="Last Name"
          value={form.last_name}
          onChange={(e) => setForm({ ...form, last_name: e.target.value })}
          className="w-full px-6 py-5 rounded-2xl border-2 text-xl"
          required
        />
        <input
          type="email"
          placeholder="Email"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          className="w-full px-6 py-5 rounded-2xl border-2 text-xl"
          required
        />
        <input
          type="text"
          placeholder="Phone Number"
          value={form.phone_number}
          onChange={(e) => setForm({ ...form, phone_number: e.target.value })}
          className="w-full px-6 py-5 rounded-2xl border-2 text-xl"
          required
        />
        <input
          type="password"
          placeholder="Password"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
          className="w-full px-6 py-5 rounded-2xl border-2 text-xl"
          required
        />
        <input
          type="password"
          placeholder="Confirm Password"
          value={form.password_confirmation}
          onChange={(e) => setForm({ ...form, password_confirmation: e.target.value })}
          className="w-full px-6 py-5 rounded-2xl border-2 text-xl"
          required
        />

        <button
          type="submit"
          className="w-full py-8 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white font-black text-3xl rounded-3xl shadow-2xl transition transform hover:scale-105"
        >
          Create Admin Account
        </button>
      </form>
    </div>
  );
}